let tcCookie = {
  v: {
      cookieName: null,
      expireDays: null
  },
  initialize: function (init) {
      $.extend(this.v, init);
  },
  set: function () {
      var date = new Date();
      date.setTime(date.getTime() + (this.v.expireDays * 24 * 60 * 60 * 1000));
      document.cookie = this.v.cookieName + "=true; expires=" + date.toGMTString() + "; path=/";
  },
  get: function () {
      var name = this.v.cookieName + "=";
      var aCookies = document.cookie.split(';');
      for (var i = 0; i < aCookies.length; i++) {
          var iCookie = aCookies[i].trim();
          if (iCookie.indexOf(name) === 0) {
              return iCookie.substring(name.length, iCookie.length);
          }
      }
      return false;
  }
};

export default tcCookie;